import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowUIService implements OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();

  private showUI$ = new BehaviorSubject<boolean>(null);

  ngOnDestroy(): void {
    this.set(false);
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  // Says, if layout.html should hide hornavbar and sidenav.
  set(value: boolean): void {
    this.showUI$.next(value);
  }

  get showUI(): BehaviorSubject<boolean> {
    return this.showUI$;
  }

}
